const userErrorFragment = `{
  field
  message
}`;

const checkoutUserErrorFragment = `{
  field
  message
  code
}`;

export { userErrorFragment, checkoutUserErrorFragment };
